<template>
  <div class="pwc-self-update">
    <van-nav-bar
      :title="cTitle"
      left-text="取消"
      right-text="保存"
      fixed
      @click-left="handleReturn"
      @click-right="handleSave"
    />

    <pwc-container>
      <pwc-avatar class="pwc-self-avatar" :upload="handleUpdateAvatar" :avatar="userInfo.profilePhotoUrl" />

      <van-cell-group title="基本信息" :border="false" class="pwc-self-basic">
        <van-field v-model="name" required label="姓名" />
        <van-field v-model="email" required label="邮箱" />
        <van-field v-model="cAge" required placeholder="请选择" is-link readonly label="年龄" @click="handleUpdateAge" />
        <!-- <van-field v-model="CEducationOrWork" required placeholder="请选择" is-link readonly label="教育或工作" @click="handleEducationOrWork" /> -->
        <van-field required>
          <template #input>
            <van-radio-group v-model="educationOrWork" direction="horizontal" style="display: flex;">
              <van-radio :name="0" style="margin-right: 10px;">在校学生</van-radio>
              <van-radio :name="1">职场人士</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group v-if="cShowEducation" title="教育" :border="false" class="pwc-self-student">
        <van-field v-model="eduInstitution" required label="学校" />
        <van-field v-model="major" required label="专业" />
        <van-field v-model="cGrade" required placeholder="请选择" is-link readonly label="年级" @click="handleUpdateGrade" />
      </van-cell-group>

      <van-cell-group v-if="cShowWorkInfo" title="工作" :border="false" class="pwc-self-worker">
        <van-field v-model="company" required label="公司" />
        <van-field v-model="title" required label="职位" />
        <van-field v-model="cWorkYear" required placeholder="请选择" is-link readonly label="工作年限" @click="handleUpdateWorkYear" />
        <van-field v-model="cIndustry" required placeholder="请选择" is-link readonly label="行业" @click="handleUpdateIndustry" />
        <van-field v-if="cIndustry==='其他'" v-model="industryOther" required label="其他行业" placeholder="请注明" />
      </van-cell-group>
      <van-cell-group v-if="cShowWorkInfo" title="推荐人信息">
        <van-field v-model="RefererId" label="员工ID" />
        <van-field v-model="RefererName" label="姓名" />
      </van-cell-group>
      <van-cell-group
        v-if="cShowWorkInfo && isRequiredCv === 'true'"
        title="简历"
        :border="false"
        class="pwc-self-worker"
      >
        <pwc-upload-resume
          :uploaddoclist="cfileList"
          :maxfcnt="1"
        />
      </van-cell-group>
    </pwc-container>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="cColumns"
        :default-index="defaultIndex"
        @cancel="showPicker = false"
        @confirm="handlePickerChange"
      />
    </van-popup>
  </div>
</template>

<script>
import PwcAvatar from '@/components/PwcAvatar'
import { Dialog, NavBar, CellGroup, Field, Picker, Popup, RadioGroup, Radio } from 'vant'
import { logic } from '../common/mixin/logic'
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import PwcUploadResume from '@/components/PwcUploadResume'
const ColumnType = {
  Age: 0,
  Grade: 1,
  WorkYear: 2,
  Industry: 3,
  EducationOrWork: 4
}
const educationOrWorkList = [{ id: 0, name: '在校学生' }, { id: 1, name: '职场人士' }]
export default {
  components: {
    VanNavBar: NavBar,
    VanCellGroup: CellGroup,
    VanField: Field,
    VanPicker: Picker,
    VanPopup: Popup,
    PwcContainer,
    PwcAvatar,
    PwcUploadResume,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  mixins: [logic],
  data() {
    return {
      showPicker: false,
      defaultIndex: 0,
      ColType: ColumnType.Age
    }
  },
  computed: {
    cfileList() {
      return []
    },
    cTitle() {
      return `完善基本信息`
    },
    cColumns() {
      if (this.ColType === ColumnType.Age) {
        return this.lookups.ageRange || []
      }
      if (this.ColType === ColumnType.Grade) {
        return this.lookups.anchorStudentGrades || []
      }
      if (this.ColType === ColumnType.WorkYear) {
        return this.lookups.workYearRange || []
      }
      if (this.ColType === ColumnType.Industry) {
        return this.lookups.industries || []
      }
      if (this.ColType === ColumnType.EducationOrWork) {
        return educationOrWorkList || []
      }
      return []
    },
    cAge: {
      get() {
        const obj = (this.lookups.ageRange || []).find(v => v.id === this.age)
        if (obj) {
          return obj.name
        }
        return this.age
      },
      set(n) {
        this.age = n
      }
    },
    CEducationOrWork: {
      get() {
        const obj = (educationOrWorkList || []).find(v => v.id === this.educationOrWork)
        if (obj) {
          return obj.name
        }
        return this.educationOrWork
      },
      set(n) {
        this.educationOrWork = n
      }
    },
    cGrade: {
      get() {
        const obj = (this.lookups.anchorStudentGrades || []).find(v => v.id === this.grade)
        if (obj) {
          return obj.name
        }
        return this.grade
      },
      set(n) {
        this.grade = n
      }
    },
    cWorkYear: {
      get() {
        const obj = (this.lookups.workYearRange || []).find(v => v.id === this.yearsOfWork)
        if (obj) {
          return obj.name
        }
        return this.yearsOfWork
      },
      set(n) {
        this.yearsOfWork = n
      }
    },
    cIndustry: {
      get() {
        const obj = (this.lookups.industries || []).find(v => v.id === this.industryId)
        if (obj) {
          return obj.name
        }
        return this.industryId
      },
      set(n) {
        this.industryId = n
      }
    }
  },
  methods: {
    handleDialogConfirm(cb) {
      // component implemented
      Dialog.confirm({
        message: '确认取消修改？'
      }).then(() => {
        cb()
      }).catch(() => {
        // cancel return, do nothing
      })
    },
    handleDialogMessage(msg) {
      // component implemented
      Dialog.alert({
        message: msg
      })
    },
    handlePickerChange(v) {
      this.showPicker = false
      if (this.ColType === ColumnType.Age) {
        this.age = v.id
      }
      if (this.ColType === ColumnType.Grade) {
        this.grade = v.id
      }
      if (this.ColType === ColumnType.WorkYear) {
        this.yearsOfWork = v.id
      }
      if (this.ColType === ColumnType.Industry) {
        this.industryId = v.id
      }
      if (this.ColType === ColumnType.EducationOrWork) {
        this.educationOrWork = v.id
      }
    },
    handleUpdateAge() {
      this.showPicker = true
      this.defaultIndex = (this.lookups.ageRange || []).findIndex(v => v.id === this.age)
      this.ColType = ColumnType.Age
    },
    handleEducationOrWork() {
      this.showPicker = true
      this.defaultIndex = (educationOrWorkList || []).findIndex(v => v.id === this.educationOrWork)
      this.ColType = ColumnType.EducationOrWork
    },
    handleUpdateGrade() {
      this.showPicker = true
      this.defaultIndex = (this.lookups.anchorStudentGrades || []).findIndex(v => v.id === this.grade)
      this.ColType = ColumnType.Grade
    },
    handleUpdateWorkYear() {
      this.showPicker = true
      this.defaultIndex = (this.lookups.workYearRange || []).findIndex(v => v.id === this.yearsOfWork)
      this.ColType = ColumnType.WorkYear
    },
    handleUpdateIndustry() {
      this.showPicker = true
      this.defaultIndex = (this.lookups.industries || []).findIndex(v => v.id === this.industryId)
      this.ColType = ColumnType.Industry
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-self-update {
  // position: fixed;
  // width: 100vw;
  // height: calc(100vh - 46px);
  // margin-top: 46px;
  // overflow-y: scroll;
  // -webkit-overflow-scrolling: touch;
  // background-color: #f7f7f7;
  // background-color: #ededed;
  .pwc-self-avatar {
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
